const styles = {
  root: {
    height: '100vh',
    '& .selected-item': {
      border: '1px solid #dadada',
      padding: 8,
    },
    '& .floating-action': {
      backgroundColor: '#fff',
      position: 'absolute',
      bottom: 0,
      left: 0,
      right: 0,
      paddingBottom: 8,
      paddingTop: 8,
      // border: '1px solid #F3F3F3',
    },
  },
};

export default styles;
